import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from '@material-ui/lab';

const PlayListPlayerShimmer = (props) => {
    const items = [...Array(4)];
  return (
    <div>
        {items.map((_,index) =>( <div className='playlist-page-shimmer video-wrapper' key={index}>
                        <div className="playlist-page-shimmer-item">
                          <Skeleton variant="rect" width={'100%'} height={100} />
                        </div>
                        {index < 4 ? <div className="line"></div> : null}
                    </div>
                  )
        )}
    </div>
  )
}

PlayListPlayerShimmer.propTypes = {

}

export { PlayListPlayerShimmer }